import type { UserRole, UserStatus } from '../types/admin';

export const USER_STATUS_LABEL: Record<UserStatus, string> = {
  active: '正常',
  disabled: '已禁用',
};

export const USER_ROLE_LABEL: Record<UserRole, string> = {
  owner: '负责人',
  groomer: '洗护师',
};
